import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the ColorConvertProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ColorConvertProvider {

  constructor(public http: HttpClient) {
  }

  hexToRgba(hex, a) {
    if (hex.charAt(0) === '#'){
      hex = hex.slice(1)
    }
    var bigint = parseInt(hex, 16);
    var r = (bigint >> 16) & 255;
    var g = (bigint >> 8) & 255;
    var b = bigint & 255;
    return 'rgba('+ r + "," + g + "," + b + "," + a +')';
  }
  hexToRgb(hex) {
    if (hex.charAt(0) === '#'){
      hex = hex.slice(1)
    }
    var bigint = parseInt(hex, 16);
    var r = (bigint >> 16) & 255;
    var g = (bigint >> 8) & 255;
    var b = bigint & 255;
    return 'rgb('+ r + "," + g + "," + b + ')';
  }

}



// WEBPACK FOOTER //
// ./src/providers/color-convert/color-convert.ts